module.exports = __webpack_public_path__ + "static/media/amstel gold race.4a6e03b3.jpg";